import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, defineMessages } from 'react-intl'

// components
import { SquareIcon, Text } from '../../../../..'

// constants
import { MARKET_VALUE_BREAK_POINTS } from '../../../../../../constants/marketRecords'
import { MARKET_TEMP_KEYS } from '../../../../../../constants/shouldYouSell'

// selectors
import { selectLatestQuartileMarketValue } from '../../../../../../store/selectors/marketRecord'

// styles
import baseStyles from '../../ShouldYouSell.module.scss'

const titles = defineMessages({
  [MARKET_TEMP_KEYS.HOTISH]: {
    id: 'ShouldYouSell.MarketTempSellLabel.title.hotish',
    defaultMessage: 'In demand market'
  },
  [MARKET_TEMP_KEYS.BALANCED]: {
    id: 'ShouldYouSell.MarketTempSellLabel.title.balanced',
    defaultMessage: 'Balanced market'
  },
  [MARKET_TEMP_KEYS.COLDISH]: {
    id: 'ShouldYouSell.MarketTempSellLabel.title.coldish',
    defaultMessage: 'Cooler market'
  }
})

const subTitles = defineMessages({
  [MARKET_TEMP_KEYS.HOTISH]: {
    id: 'ShouldYouSell.MarketTempSellLabel.sub.hotish',
    defaultMessage: 'Competition is high, inventory is low'
  },
  [MARKET_TEMP_KEYS.BALANCED]: {
    id: 'ShouldYouSell.MarketTempSellLabel.sub.balanced',
    defaultMessage: 'Competition and inventory are neutral'
  },
  [MARKET_TEMP_KEYS.COLDISH]: {
    id: 'ShouldYouSell.MarketTempSellLabel.sub.coldish',
    defaultMessage: 'Competition is low, inventory is high'
  }
})

const MarketTempSellLabel = () => {
  const latestMarketValue = useSelector(selectLatestQuartileMarketValue)

  let key
  let variant
  let icon

  if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.HIGH) {
    key = MARKET_TEMP_KEYS.HOTISH
    variant = 'success'
    icon = 'graph'
  } else if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.MODERATE) {
    key = MARKET_TEMP_KEYS.BALANCED
    variant = 'success'
    icon = 'graph'
  } else {
    key = MARKET_TEMP_KEYS.COLDISH
    variant = 'warning'
    icon = 'snowflake'
  }

  return (
    <>
      <SquareIcon
        className={baseStyles.icon}
        backgroundColor={variant === 'success' ? 'success' : 'warning'}
        icon={icon}
      />
      <div className={baseStyles.label}>
        <Text size='s' variant={variant} weight='semibold'>
          <FormattedMessage {...titles[key]} />
        </Text>
        <Text size='xs' variant='neutralCool' variantCount='700'>
          <FormattedMessage {...subTitles[key]} />
        </Text>
      </div>
    </>
  )
}

export default MarketTempSellLabel
